<div class="pos-relative">
  <div #container
    [class.pe-none]="!isCheckoutValid"
    class="adyen-google-pay-component"
  id="adyen-google-pay-container"></div>
  @if (!isCheckoutValid) {
    <button class="fill"
      (click)="validateCheckout()"
    type="button"></button>
  }
</div>
@if (googlePayAvailableStatus.error) {
  <p class="fs-3 col-2"
  >{{googlePayAvailableStatus.error}}</p>
}